import axios from 'axios';

/**
 * apiの設計 ベイジサーバー用（認証なし） or ベイジサーバー用（認証あり） or 本番サーバー用
 * 1 - 本番サーバー用
 * 2 - ベイジサーバー用（認証なし）
 * 3 - ベイジサーバー用（認証あり）
 */
const configAPI = () => {
  return 3;
}

/**
 * カテゴリデータを取得（api）
 */
export const getCategoryData = () => {
  let categoryUrl = '';
  if(configAPI() === 1) {
    categoryUrl = '';
  } else if(configAPI() === 2){
    categoryUrl = '/recruit/entry/json/newgrad_category.json'; // ローカルで実行するためにクロスドメインを外したもの
  } else if(configAPI() === 3) {
    categoryUrl = '/recruit/entry/newgrad_category.json'; // cyrテスト環境用
  } else {
    categoryUrl = '/recruit/entry/json/newgrad_category.json';
  };
  return axios.get(categoryUrl);
}

/**
 * カテゴリデータ順を取得（api）
 */
export const getCategoryList = () => {
  let categoryUrl = '';
  if(configAPI() === 1) {
    categoryUrl = '';
  } else if(configAPI() === 2){
    categoryUrl = '/recruit/entry/json/newgrad_category_list.json'; // ローカルで実行するためにクロスドメインを外したもの
  } else if(configAPI() === 3) {
    categoryUrl = '/recruit/entry/newgrad_category_list.json'; // cyrテスト環境用
  } else {
    categoryUrl = '/recruit/entry/json/newgrad_category_list.json';
  };
  return axios.get(categoryUrl);
}

/**
 * 記事データを取得する（api）
 */
export const getArticleData = () => {
  let articleUrl = '';
  if(configAPI() === 1) {
    articleUrl = '';
  } else if(configAPI() === 2){
    articleUrl = '/recruit/entry/json/newgrad_article.json'; //ローカルで実行できるようにクロスドメインを外したもの
  } else if(configAPI() === 3) {
    articleUrl = '/recruit/entry/newgrad_article.json'; // cyrテスト環境用
  } else {
    articleUrl = '/recruit/entry/json/newgrad_article.json';
  };
  return axios.get(articleUrl);
}

/**
 * アサイド記事を取得する（api）
 */
export const getAsideArticleData = () => {
  let asideArticleUrl = '';
  if(configAPI() === 1) {
    asideArticleUrl = '';
  } else if(configAPI() === 2){
    asideArticleUrl = '/recruit/entry/json/newgrad_aside_article.json'; //ローカルで実行できるようにクロスドメインを外したもの
  } else if(configAPI() === 3) {
    asideArticleUrl = '/recruit/entry/newgrad_aside_article.json'; // cyrテスト環境用
  } else {
    asideArticleUrl = '/recruit/entry/json/newgrad_aside_article.json';
  };
  return axios.get(asideArticleUrl);
}


/**
 * ローカルテスト用カテゴリデータ
 */
export const originalNewgradCatData = {
  '職種':{
    // 'all': {
    //   title: 'すべて',
    //   id: '職種-0',
    //   isActive: false,
    // },
    '13':{
      title: 'コーポレート職',
      id: 13,
      isActive: false,
      child: {
          47: {
            title: 'コーポレート職-4',
            id: 47,
            isActive: false,
          },
          48: {
            title: 'コーポレート職-3',
            id: 48,
            isActive: false,
          },
          49: {
            title: 'コーポレート職-2',
            id: 49,
            isActive: false,
          },
          50: {
            title: 'コーポレート職-1',
            id: 50,
            isActive: false,
          },
      },
    },
    '14':{
      title: 'ビジネス職',
      id: 14,
      isActive: false,
      child: {
          51: {
            title: 'ビジネス職-4',
            id: 51,
            isActive: false,
          },
          52: {
            title: 'ビジネス職-3',
            id: 52,
            isActive: false,
          },
          53: {
            title: 'ビジネス職-2',
            id: 53,
            isActive: false,
          },
          54: {
            title: 'ビジネス職-1',
            id: 54,
            isActive: false,
          },
      },
    },
    '12':{
      title: 'エンジニア職',
      id: 12,
      isActive: false,
      child: {
          15: {
            title: '"カスタマーサービス',
            id: 15,
            isActive: false,
          },
          16: {
            title: '情報システム',
            id: 16,
            isActive: false,
          },
          17: {
            title: 'デベロッパーマーケティング',
            id: 17,
            isActive: false,
          },
          18: {
            title: 'インフラ開発/運用',
            id: 18,
            isActive: false,
          },
          19: {
            title: 'システムコンサルティング',
            id: 19,
            isActive: false,
          },
          20: {
            title: 'サービス開発支援',
            id: 20,
            isActive: false,
          },
          21: {
            title: 'サービス開発/運用',
            id: 21,
            isActive: false,
          },
      },
    },
  },
  '入社時期':{
    // 'all': {
    //   title: 'すべて',
    //   id: '入社時期-0',
    // },
    '22':{
      title: 'フルリモート',
      id: 22,
      isActive: false,
    },
    '23':{
      title: '福岡',
      id: 23,
      isActive: false,
    },
    '24':{
      title: '広島',
      id: 24,
      isActive: false,
    },
    '25':{
      title: '松山',
      id: 25,
      isActive: false,
    },
    '26':{
      title: '大阪',
      id: 26,
      isActive: false,
    },
    '27':{
      title: '名古屋',
      id: 27,
      isActive: false,
    },
    '28':{
      title: '横浜',
      id: 28,
      isActive: false,
    },
    '29':{
      title: '仙台',
      id: 29,
      isActive: false,
    },
    '30':{
      title: '札幌',
      id: 30,
      isActive: false,
    },
    '31':{
      title: '東京',
      id: 31,
      isActive: false,
    },
  },
  '採用区分':{
    // 'all': {
    //   title: 'すべて',
    //   id: '採用区分-0',
    // },
    '32':{
      title: '障害者採用',
      id: 32,
      isActive: false,
    },
    '33':{
      title: 'ポテンシャル採用',
      id: 33,
      isActive: false,
    },
  }
}


/**
 * ローカルテスト用記事データ
 */
export const originalNewgradArticlesData = {"21":{"id": 21,"title": "新卒採用テスト用記事-5","link": "/recruit/entry/2021/09/d56204b33c813fb14a135d367b589586db7e7461.html","descForArchive": "コーポレート職,福岡,広島,松山,大阪,名古屋,障害者採用,ポテンシャル採用","categorys": {"13": {"title": "コーポレート職","type": "job"},"23": {"title": "福岡","type": "ym"},"24": {"title": "広島","type": "ym"},"25": {"title": "松山","type": "ym"},"26": {"title": "大阪","type": "ym"},"27": {"title": "名古屋","type": "ym"},"32": {"title": "障害者採用",},"33": {"title": "ポテンシャル採用",},},"salary": "○○万円～"},"20":{"id": 20,"title": "新卒採用テスト用記事-4","link": "/recruit/entry/2021/09/8cc13a72953b6e70f98cdde83191a27f49065ffc.html","descForArchive": "ビジネス職 » ビジネス職-3,コーポレート職 » コーポレート職-2,エンジニア職 » デベロッパーマーケティング,エンジニア職 » インフラ開発/運用,エンジニア職 » システムコンサルティング,コーポレート職 » コーポレート職-1,コーポレート職 » コーポレート職-4,広島,ポテンシャル採用\r\n","categorys": {"52": {"title": "ビジネス職-3","type": "job"},"49": {"title": "コーポレート職-2","type": "job"},"17": {"title": "デベロッパーマーケティング","type": "job"},"18": {"title": "インフラ開発/運用","type": "job"},"19": {"title": "システムコンサルティング","type": "job"},"50": {"title": "コーポレート職-1","type": "job"},"47": {"title": "コーポレート職-4","type": "job"},"24": {"title": "広島","type": "ym"},"33": {"title": "ポテンシャル採用",},},"salary": "○○万円～"},"19":{"id": 19,"title": "新卒採用テスト用記事-3","link": "/recruit/entry/2021/09/141d7fabd61a6659c0d383a16dd62e880b9b35b8.html","descForArchive": "ビジネス職=>ビジネス職-3,仙台,障碍者採用","categorys": {"52": {"title": "ビジネス職-3","type": "job"},"29": {"title": "仙台","type": "ym"},"32": {"title": "障害者採用",},},"salary": "○○万円～"},"18":{"id": 18,"title": "新卒採用テスト用記事-2","link": "/recruit/entry/2021/09/11e67452d785a9205c2423186cc3719d6e474b4d.html","descForArchive": "エンジニア職=>システムコンサルティング,大阪","categorys": {"19": {"title": "システムコンサルティング","type": "job"},"26": {"title": "大阪","type": "ym"},},"salary": "○○万円～"},"17":{"id": 17,"title": "新卒採用テスト用記事-1","link": "/recruit/entry/2021/09/0446bbce2b06be0d3e635440d11b45c8f397baba.html","descForArchive": "コーポレート職 =>コーポレート職-4,ビジネス職 =>ビジネス職-2,エンジニア職=>デベロッパーマーケティング,名古屋,ポテンシャル採用\r\n","categorys": {"47": {"title": "コーポレート職-4","type": "job"},"53": {"title": "ビジネス職-2","type": "job"},"17": {"title": "デベロッパーマーケティング","type": "job"},"27": {"title": "名古屋","type": "ym"},"33": {"title": "ポテンシャル採用",},},"salary": ""},"14":{"id": 14,"title": "【サービス開発/運用】Webエンジニア（リモートサービス）","link": "/recruit/entry/2021/08/ca613e7ebe169f31c65e780bf4577cb02be984bd.html","descForArchive": "","categorys": {"12": {"title": "エンジニア職","type": "job"},"22": {"title": "フルリモート","type": "ym"},"33": {"title": "ポテンシャル採用",},},"salary": ""},"13":{"id": 13,"title": "【サービス開発/運用】Webエンジニア（販売管理システム）","link": "/recruit/entry/2021/08/d073c827e36c51cf494c7ab86c34001e3fda8661.html","descForArchive": "","categorys": {"12": {"title": "エンジニア職","type": "job"},},"salary": ""},"12":{"id": 12,"title": "【サービス開発/運用】Webエンジニア（kintone サーバーサイド）","link": "/recruit/entry/2021/08/b809edd5db6e4cbcb78f46977f44452364d1e3b3.html","descForArchive": "","categorys": {"12": {"title": "エンジニア職","type": "job"},"27": {"title": "名古屋","type": "ym"},"26": {"title": "大阪","type": "ym"},"32": {"title": "障害者採用",},"33": {"title": "ポテンシャル採用",},},"salary": ""},}


/**
 * ローカルテスト用サポート記事のデータ
 */
export const originalNewgradAsideArticlesData = {
  "1000":{
    "id": "1000",
    "title": "障害者採用について",
    "link": "/"
  },
  "2000":{
    "id": "2000",
    "title": "インターン・アルバイトについて",
    "link": "/"
  }
}

/**
 * 選択したカテゴリ
 */
export const selectNewgradCats = {
  '職種': {},
  '入社時期': {},
  '採用区分': {}
}


/**
 * 職種カテゴリの選択項目
 */
export const selectNewgradJobType = {}



/**
 * カテゴリデータ（MTからjsonを生成するためのコード）
 */

// {
//   "職種":{
//     "a1000": {
// 			"title": "すべて",
// 			"id": "a1000",
// 			"isActive": true
// 		},
//     <mt:CategorySets name="新卒採用_職種" blog_id="10">
//     <mt:SetVar name="undef(counter)">
//     <mt:SetVar name="counter" value="0">
//     <mt:TopLevelCategories>
//       <mt:SetVar name="counter" op="++">
//       <mt:If name="counter" gt="1">,</mt:If>
//       "<$mt:CategoryID encode_json="1"$>":{
//         "title": "<$mt:CategoryLabel encode_json="1"$>",
//         "id": "<$mt:CategoryID encode_json="1"$>",
//         "isActive": false,
//         "child": {
//           "a100000<$mt:CategoryID encode_json="1"$>": {
//             "title": "すべて",
//             "id": "a100000<$mt:CategoryID encode_json="1"$>",
//             "isActive": false
//           },
//           <mt:SetVar name="undef(counter)">
//           <mt:SetVar name="counter" value="0">
//           <mt:SubCategories>
//             <mt:SetVar name="counter" op="++">
//             <mt:If name="counter" gt="1">,</mt:If>
//             "<$mt:CategoryID encode_json="1"$>": {
//               "title": "<$mt:CategoryLabel encode_json="1"$>",
//               "id": "<$mt:CategoryID encode_json="1"$>",
//               "isActive": false
//             }
//           </mt:SubCategories>
//         }
//       }
//     </mt:TopLevelCategories>
//   </mt:CategorySets>
//   },
//   "入社時期":{
//     "a2000": {
// 			"title": "すべて",
// 			"id": "a2000",
// 			"isActive": true
// 		},
//   <mt:CategorySets name="新卒採用_入社時期" blog_id="10">
//     <mt:SetVar name="undef(counter)">
//     <mt:SetVar name="counter" value="0">
//     <mt:TopLevelCategories>
//       <mt:SetVar name="counter" op="++">
//       <mt:If name="counter" gt="1">,</mt:If>
//       "<$mt:CategoryID encode_json="1"$>":{
//         "title": "<$mt:CategoryLabel encode_json="1"$>",
//         "id": "<$mt:CategoryID encode_json="1"$>",
//         "isActive": false
//       }
//     </mt:TopLevelCategories>
//   </mt:CategorySets>
//   },
//   "採用区分":{
//     "a3000": {
// 			"title": "すべて",
// 			"id": "a3000",
// 			"isActive": true
// 		},
//   <mt:CategorySets name="新卒採用_採用区分" blog_id="10">
//     <mt:SetVar name="undef(counter)">
//     <mt:SetVar name="counter" value="0">
//     <mt:TopLevelCategories>
//       <mt:SetVar name="counter" op="++">
//       <mt:If name="counter" gt="1">,</mt:If>
//       "<$mt:CategoryID encode_json="1"$>":{
//         "title": "<$mt:CategoryLabel encode_json="1"$>",
//         "id": "<$mt:CategoryID encode_json="1"$>",
//         "isActive": false
//       }
//     </mt:TopLevelCategories>
//   </mt:CategorySets>
//   }
// }
{/* {"職種":{"職種-all": {"title": "すべて","id": "職種-all","isActive": false},<mt:CategorySets name="新卒採用_職種" blog_id="10"><mt:SetVar name="undef(counter)"><mt:SetVar name="counter" value="0"><mt:TopLevelCategories><mt:SetVar name="counter" op="++"><mt:If name="counter" gt="1">,</mt:If>"<$mt:CategoryID encode_json="1"$>":{"title": "<$mt:CategoryLabel encode_json="1"$>","id": "<$mt:CategoryID encode_json="1"$>","isActive": false,"child": {<mt:SetVar name="undef(counter)"><mt:SetVar name="counter" value="0"><mt:SubCategories><mt:SetVar name="counter" op="++"><mt:If name="counter" gt="1">,</mt:If>"<$mt:CategoryID encode_json="1"$>": {"title": "<$mt:CategoryLabel encode_json="1"$>","id": "<$mt:CategoryID encode_json="1"$>","isActive": false}</mt:SubCategories>}}</mt:TopLevelCategories></mt:CategorySets>},"入社時期":{"入社時期-all": {"title": "すべて","id": "入社時期-all","isActive": false},<mt:CategorySets name="新卒採用_入社時期" blog_id="10"><mt:SetVar name="undef(counter)"><mt:SetVar name="counter" value="0"><mt:TopLevelCategories><mt:SetVar name="counter" op="++"><mt:If name="counter" gt="1">,</mt:If>"<$mt:CategoryID encode_json="1"$>":{"title": "<$mt:CategoryLabel encode_json="1"$>","id": "<$mt:CategoryID encode_json="1"$>","isActive": false}</mt:TopLevelCategories></mt:CategorySets>},"採用区分":{"採用区分-all": {"title": "すべて","id": "採用区分-all","isActive": false},<mt:CategorySets name="新卒採用_採用区分" blog_id="10"><mt:SetVar name="undef(counter)"><mt:SetVar name="counter" value="0"><mt:TopLevelCategories><mt:SetVar name="counter" op="++"><mt:If name="counter" gt="1">,</mt:If>"<$mt:CategoryID encode_json="1"$>":{"title": "<$mt:CategoryLabel encode_json="1"$>","id": "<$mt:CategoryID encode_json="1"$>","isActive": false}</mt:TopLevelCategories></mt:CategorySets>}} */}
// http://cyr:g7SEFnb4@cyr.baigie.me/recruit/entry/newgrad_category.json


/**
 * 記事データ（MTからjsonを生成するためのコード）
 */
// "descForArchive": "<mt:ContentField content_field="記事一覧用説明文"><mt:ContentFieldValue encode_json="1"></mt:ContentField>",
// {
//   <mt:Contents content_type="新卒採用"  blog_id="10">
//   "<mt:ContentID>":{
//     "id": "<mt:ContentID>",
//     "title": "<mt:ContentLabel encode_json="1">",
//     "link": "<mt:ContentPermalink encode_json="1">",
//     "categorys": {
//     <mt:ContentField content_field="職種カテゴリ">
//       "<mt:ContentFieldValue encode_json="1">": {
//         "title": "<$mt:CategoryLabel encode_json="1"$>",
//         "type": "job"
//       }
//       <mt:If name="__last__">
//         <mt:SetVar name="jobcounter" value="0">
//           <mt:ContentField content_field="入社時期カテゴリ"><mt:SetVar name="jobcounter" op="++"></mt:ContentField>
//         <mt:If name="jobcounter" ge="1">,</mt:If>
//       <mt:Else>
//         ,
//       </mt:If>
//     </mt:ContentField><mt:ContentField content_field="入社時期カテゴリ">
//       "<mt:ContentFieldValue encode_json="1">": {
//         "title": "<$mt:CategoryLabel encode_json="1"$>",
//         "type": "ym"
//       }
//       <mt:If name="__last__">
//         <mt:SetVar name="jobcounter" value="0">
//           <mt:ContentField content_field="採用区分カテゴリ"><mt:SetVar name="jobcounter" op="++"></mt:ContentField>
//         <mt:If name="jobcounter" ge="1">,</mt:If>
//       <mt:Else>
//         ,
//       </mt:If>
//     </mt:ContentField><mt:ContentField content_field="採用区分カテゴリ">
//       "<mt:ContentFieldValue encode_json="1">": {
//         "title": "<$mt:CategoryLabel encode_json="1"$>",
//         "type": "oth"
//       }<mt:If name="__last__"><mt:Else>,</mt:If>
//     </mt:ContentField>
//     },
//     "attribute": "<mt:ContentField content_field="職種（記事表示用）"><$mt:CategoryLabel encode_json="1"$></mt:ContentField>"
//   }<mt:If name="__last__"><mt:Else>,</mt:If>
// </mt:Contents>
// }
// http://cyr:g7SEFnb4@cyr.baigie.me/recruit/entry/newgrad_article.json


